
import { computed, defineComponent, ref } from "vue";

import { CBtn, CIcon } from "../../vuetify-components";

export default defineComponent({
  components: { CBtn, CIcon },
  props: {
    fab: {
      type: [Boolean, String],
      default: true,
    },
    isLiked: {
      type: [Boolean, String],
      default: false,
    },
    opacity: {
      type: Number,
      default: 86,
    },
  },
  setup(props, _context) {
    const isHover = ref(false);
    const isFocus = ref(false);

    const backgroundColor = computed(() => (isHover.value ? "grey-20" : isFocus.value ? "grey-10" : "ltk-whitn"));
    const heartColor = computed(() => (props.isLiked ? "secondary-60" : undefined));
    const heartIcon = computed(() =>
      props.isLiked ? "capsule-consumer-heart-logo-fill-16" : "capsule-consumer-heart-logo-outline-16",
    );

    return {
      isHover,
      isFocus,
      backgroundColor,
      heartColor,
      heartIcon,
    };
  },
});
